import {ReportsContainer} from './report-container';

export default {
    component: ReportsContainer
};
